module.exports = __webpack_public_path__ + "abac6eba62497e092622fdb3bfcee160.pdf";